import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import startsWith from 'lodash/startsWith';
import { State, getState } from '../../js/utils/applicationState';
const adInterface = {
    init() {
        global.addEventListener('message', this.handleMessage.bind(this), false);
    },
    isValidUnlockParameter(data) {
        return data?.campaignId && data.campaignKey && data.unlockToken;
    },
    handleUnlockMessage(data) {
        const premiumUnlockCallback = getState(State.onPremiumUnlockEvent);
        if (premiumUnlockCallback &&
            isFunction(premiumUnlockCallback) &&
            this.isValidUnlockParameter(data)) {
            premiumUnlockCallback(data);
        }
    },
    handleMessage(event) {
        if (!(event.data && isString(event.data) && startsWith(event.data, 'ti:'))) {
            return;
        }
        const json = event.data.substring(3);
        let data;
        try {
            data = JSON.parse(json);
        }
        catch (e) {
            return;
        }
        if (data.type === 'premiumUnlock') {
            this.handleUnlockMessage(data);
        }
    },
};
export default adInterface;
